import React from 'react';
import AppLogo from '../../../components/ui/AppLogo';

const BrandingSection = () => {
  return (
    <div className="flex flex-col items-center space-y-6 mb-8 lg:mb-10">
      <AppLogo size="lg" variant="full" />

      <p className="text-sm md:text-base font-bold text-muted-foreground text-center max-w-md mx-auto px-4">
        Geração dinâmica de documentos com segurança e praticidade
      </p>
    </div>
  );
};

export default BrandingSection;
